import React from 'react';
import { Box, Stack, SelectChangeEvent } from '@mui/material';
import { PolicyProvider, usePolicyContext } from './PolicyContext';
import MetricsCards from './MetricsCards';
import OrganizationalTrends from './OrganizationalTrends';
import LexipolUpdatesChart from './LexipolUpdatesChart';
import AssignmentsChart from './AssignmentsChart';

function PolicyContent() {
  const { manualId, setManualId } = usePolicyContext();

  const handleManualChange = (event: SelectChangeEvent<string>) => {
    setManualId(event.target.value);
  };

  const handleReportSelect = (reportType: string) => {
    // TODO: Navigate to report pages when they exist
    console.log(`Navigate to ${reportType} report`);
  };

  return (
    <Box sx={{ py: 3, px: 5, maxWidth: '1200px', mx: 'auto' }}>
      <Stack
        spacing={6}
        sx={{ minWidth: 0 }}
      >
        {/* Metrics Cards */}
        <MetricsCards />

        {/* Organizational Trends Chart with Filters */}
        <OrganizationalTrends
          selectedManual={manualId}
          onManualChange={handleManualChange}
          onReportSelect={handleReportSelect}
        />

        {/* Bottom Charts */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: 'minmax(331px, 1fr) 2fr' },
            gap: 3,
          }}
        >
          <LexipolUpdatesChart />
          <AssignmentsChart />
        </Box>
      </Stack>
    </Box>
  );
}

export default function Policy() {
  return (
    <PolicyProvider>
      <PolicyContent />
    </PolicyProvider>
  );
}
